// extracted by mini-css-extract-plugin
module.exports = {"section-not-found":"not-found_section-not-found__RFYdc","text404":"not-found_text404__3eEpZ","btn-go-back":"not-found_btn-go-back__1MTwe"};